import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private themeSubject = new BehaviorSubject<'light' | 'dark'>('dark');
	theme$ = this.themeSubject.asObservable();

	constructor(@Inject(PLATFORM_ID) private platformId: object) {}

	setTheme(theme: 'light' | 'dark') {
		if (isPlatformBrowser(this.platformId)) {
			document.documentElement.setAttribute('data-theme', theme);
		}
		this.themeSubject.next(theme);
	}

	getTheme(): 'light' | 'dark' {
		return this.themeSubject.value;
	}
}
